<div class="w-full h-full flex flex-col overflow-hidden bg-gray-100">
  <!-- Page Header with Title and Tabs -->
  <div class="flex-shrink-0 bg-white shadow-sm">
    <div class="flex border-b border-gray-300 -mb-px">
      <button (click)="activeTab.set('CUSTOMER')" class="px-6 py-3 font-semibold transition-colors border-b-2"
        [class.border-indigo-600]="activeTab() === 'CUSTOMER'" [class.text-indigo-700]="activeTab() === 'CUSTOMER'"
        [class.border-transparent]="activeTab() !== 'CUSTOMER'" [class.text-[#111111]]="activeTab() !== 'CUSTOMER'"
        [class.hover:]="activeTab() !== 'CUSTOMER'" [class.hover:border-gray-300]="activeTab() !== 'CUSTOMER'">
        {{ "CUSTMSTR0021" | translate }}
      </button>
      <button (click)="activeTab.set('PREPAYMENT')" class="px-6 py-3 font-semibold transition-colors border-b-2"
        [class.border-indigo-600]="activeTab() === 'PREPAYMENT'" [class.text-indigo-700]="activeTab() === 'PREPAYMENT'"
        [class.border-transparent]="activeTab() !== 'PREPAYMENT'" [class.text-[#111111]]="activeTab() !== 'PREPAYMENT'"
        [class.hover:]="activeTab() !== 'PREPAYMENT'" [class.hover:border-gray-300]="activeTab() !== 'PREPAYMENT'">
        {{ "PAYMESTR0011" | translate }}
      </button>
    </div>
  </div>

  <div class="flex-1 flex flex-col p-2 min-h-0">
    @switch (activeTab()) {
    @case ("CUSTOMER") {
    <div class="flex-1 flex flex-col bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <!-- Toolbar -->
      <div
        class="p-5 border-b border-gray-200 bg-white flex flex-col xl:flex-row justify-between items-start xl:items-center gap-4">
        <div class="flex flex-col sm:flex-row gap-4 w-full xl:w-auto">
          <div class="relative group">
            <input type="text" [ngModel]="param.P_HP_NO" (keydown.enter)="searchMembers()"
              (input)="onPhoneInputSearch($event, 'P_HP_NO')"
              class="pl-2 pr-4 py-2.5 border border-gray-300 rounded-lg w-full sm:w-56 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all placeholder-gray-400"
              [placeholder]="'CUSTMSTR0013' | translate" />
          </div>
          <div class="relative group">
            <input type="text" [(ngModel)]="param.P_USER_NM" (keydown.enter)="searchMembers()" maxlength="50"
              class="pl-2 pr-4 py-2.5 border border-gray-300 rounded-lg w-full sm:w-56 outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all placeholder-gray-400"
              [placeholder]="'CUSTMSTR0014' | translate" />
          </div>
        </div>

        <div class="flex gap-2 w-full xl:w-auto overflow-x-auto pb-1 xl:pb-0">
          <button (click)="resetSearch()"
            class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-ellipsis text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px] h-[37px]">
            {{ "CUSTMSTR0066" | translate }}
          </button>
          <button (click)="searchMembers()"
            class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-ellipsis text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px] h-[37px]">
            {{ "CUSTMSTR0004" | translate }}
          </button>
          <button (click)="openModal()"
            class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-ellipsis text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px] h-[37px]">
            {{ "CUSTMSTR0006" | translate }}
          </button>
          <button (click)="deleteMembers()"
            [class]="memberChecked().length == 0 ? 'bg-gray-400 pointer-events-none' : 'bg-gray-600'"
            class="flex-1 lg:flex-none px-5 py-2.5  text-ellipsis text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px] h-[37px]">
            {{ "USERMAG0006" | translate }}
          </button>
        </div>
      </div>
      <app-material-table class="h-full min-h-0" [headers]="customerHeaders()" [data]="members()"
        [ontoggle]="ontoggle()" [rowTemplate]="customerRowTpl" [enablePagination]="true" [allSelected]="allSelected()"
        (toggleSelectAll)="toggleSelectAll($event)" [key]="'customerNo'" [width]="'w-full'" [pageSize]="P_PAGEROW"
        (nextPage)="nextPage($event)" [totalCnt]="totalCnt()" [isPaging]="true"
        [isNextPage]="isNextPage()"></app-material-table>

      <ng-template #customerRowTpl let-m>
        <tr class="hover:bg-indigo-50/50 transition-colors group cursor-pointer"
          [class.bg-indigo-50]="selectedRows().includes(m.id)" [attr.data-customer-no]="m.customerNo">
          <!-- (dblclick)="editMember(m.customerNo); $event.stopPropagation()" > -->
          <td class="border-r border-b text-center p-[0.4rem] px-2" (click)=" $event.stopPropagation()">
            <!-- <input type="checkbox" [checked]="selectedRows().includes(m.id)"
              class="rounded text-indigo-600 focus:ring-0 cursor-pointer pointer-events-none" /> -->
            <p-checkbox [ngModel]="m.checked" (ngModelChange)="toggleMember(m, $event)" [binary]="true">
            </p-checkbox>
          </td>
          <td class="border-r border-b px-2">
            {{ m.customerNo.slice(-13) }}
          </td>
          <td class="border-r border-b  hover:text-indigo-600 px-2">
            {{ m.name?.length > 20 ? (m.name | slice:0:20) + '...' : m.name }}
          </td>
          <td class="border-r border-b px-2">{{ m.phone }}</td>
          <td class="border-r border-b text-center px-2">
            {{ m.grade }}
          </td>
          <td class="border-r border-b  text-right px-2">
            {{ m.acc | currency: "" : "" : "1.0-0" }}
          </td>
          <td class="border-r border-b  text-right px-2">
            {{ m.used | currency: "" : "" : "1.0-0" }}
          </td>
          <td class="border-r border-b  text-right px-2">
            {{ m.avail | currency: "" : "" : "1.0-0" }}
          </td>
          <td class="border-r border-b  text-right px-2">
            {{ m.count | currency: "" : "" : "1.0-0" }}
          </td>
          <td class="border-r border-b  text-right px-2">
            {{ m.prepaid | currency: "" : "" : "1.0-0" }}
          </td>
          <td class=" border-b border-r px-2 text-center">{{ m.joinDate }}</td>
          <td class="border-b px-4 text-center"><i class="pi pi-pencil" (click)="editMember(m.customerNo)"></i></td>
        </tr>
      </ng-template>
    </div>
    }
    @case ("PREPAYMENT") {
    <div class="flex flex-col h-full bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <div class="p-4 border-b border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4 bg-white">
        <!-- <h3 class="   flex items-center gap-2">
          <span class="w-1 h-5 bg-red-500 rounded-full"></span>{{ "PAYMESTR0028" | translate }}
        </h3> -->
        <div class="flex gap-4">
          <div class="flex flex-wrap gap-2 bg-gray-50">
            <div class="flex items-center gap-3 relative">
              <!-- <label >{{
                "PAYMESTR0039" | translate
                }}</label> -->
              <div class="relative" (clickOutside)="showPhoneDropdown.set(false)">
                <input type="text" pInputText (keydown.enter)="searchPrepayCustomer();showPhoneDropdown.set(false)"
                  [ngModel]="prepaySearchPhone()" (ngModelChange)="onPhoneSearchInput($event)"
                  (input)="onPhoneInputSearch($event,'prepaySearchPhone')" (focus)="
                    prepaySearchPhone() &&
                      onPhoneSearchInput(prepaySearchPhone())
                  " class="border border-gray-300 px-3 py-1.5 rounded w-40 bg-white" placeholder="010-1234-5678" />
                @if (showPhoneDropdown() && filteredMembersPhone().length > 0) {
                <div
                  class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50 min-w-[300px]">
                  @for (member of filteredMembersPhone(); track member.id) {
                  <div (click)="selectMemberFromPhoneDropdown(member)"
                    class="px-3 py-2 hover:bg-indigo-50 cursor-pointer border-b  last:border-b-0">
                    <div class="flex justify-between items-center">
                      <div>
                        <div>
                          {{ member.name }}
                        </div>
                        <div>
                          {{ member.phone }}
                        </div>
                      </div>
                      <span class="px-2 py-0.5 rounded ml-2">{{
                        member.grade }}</span>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            <div class="flex items-center gap-3 relative">
              <!-- <label >{{
                "PAYMESTR0047" | translate
                }}</label> -->
              <div class="relative" (clickOutside)="showNameDropdown.set(false)">
                <input type="text" pInputText (keydown.enter)="searchPrepayCustomer();showNameDropdown.set(false)"
                  [ngModel]="prepaySearchName()" (ngModelChange)="onNameSearchInput($event)" (focus)="
                    prepaySearchName() && onNameSearchInput(prepaySearchName())
                  " class="border border-gray-300 px-3 py-1.5 rounded w-40 bg-white" maxlength="50"
                  [placeholder]="'CUSTMSTR0051' | translate" />
                @if (showNameDropdown() && filteredMembersName().length > 0) {
                <div
                  class="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50 min-w-[300px]">
                  @for (member of filteredMembersName(); track member.id) {
                  <div (click)="selectMemberFromNameDropdown(member)"
                    class="px-3 py-2 hover:bg-indigo-50 cursor-pointer border-b  last:border-b-0">
                    <div class="flex justify-between items-center">
                      <div>
                        <div>
                          {{ member.name }}
                        </div>
                        <div>
                          {{ member.phone }}
                        </div>
                      </div>
                      <span class="px-2 py-0.5 rounded   ml-2">{{
                        member.grade }}</span>
                    </div>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="flex gap-2">
          <button (click)="clearPrepaySearch()"
            class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white text-ellipsis h-[37px] rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
            {{ "STOREHQ0003" | translate }}
          </button>
          <button (click)="searchPrepayCustomer()"
            class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white text-ellipsis h-[37px] rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
            {{ "CUSTMSTR0004" | translate }}
          </button>
        </div>
      </div>

      <div class="flex-1 flex flex-col lg:flex-row overflow-hidden">
        <div
          class="w-full lg:w-[360px] xl:w-[400px] border-r border-gray-200 p-2 flex flex-col gap-6 bg-white overflow-y-auto">
          <div class="space-y-4">
            <h4 class="border-b pb-2 pt-2 border-gray-200 flex items-center font-bold">
              {{ "CUSTMSTR0021" | translate }}
            </h4>

            <div class="grid grid-cols-[100px_1fr] gap-4 items-center">
              <!-- Phone -->
              <span>{{
                "CUSTMSTR0013" | translate
                }}</span>
              <div class="border border-gray-300 px-3 py-2 rounded bg-gray-50 min-h-[40px] flex items-center">
                {{ selectedPrepayCustomer()?.phone }}
              </div>

              <!-- Name -->
              <span>{{
                "CUSTMSTR0014" | translate
                }}</span>
              <div class="border border-gray-300 px-3 py-2 rounded bg-gray-50 min-h-[40px] flex items-center">
                {{ selectedPrepayCustomer()?.name }}
              </div>

              <!-- Grade -->
              <span>{{
                "CUSTMSTR0032" | translate
                }}</span>
              <div class="border border-gray-300 px-3 py-2 rounded bg-gray-50 min-h-[40px] flex items-center">
                {{ selectedPrepayCustomer()?.grade }}
              </div>

              <!-- Prepaid -->
              <span>{{
                "CUSTMSTR0038" | translate
                }}</span>
              <div class="border border-gray-300 px-3 py-2 rounded bg-gray-50 min-h-[40px] flex items-center ">
                {{
                (selectedPrepayCustomer()?.prepaid ?? null) !== null
                ? (selectedPrepayCustomer()?.prepaid ?? 0
                | currency: "" : "" : "1.0-0")
                : ""
                }}
              </div>
            </div>
          </div>

          <div class="border border-gray-200 rounded-lg p-4 space-y-4 bg-gray-50 mt-auto">
            <div class="space-y-3">
              <div class="flex items-center justify-between">
                <span>{{
                  "CUSTMSTR0026" | translate
                  }}</span>
                <!-- <input type="text" [ngModel]="formatNumberWithCommas(prepayChargeAmount())"
                  (ngModelChange)="onChargeAmountChange($event)"
                  class="border border-gray-300 bg-white px-3 py-2 rounded w-40 text-right  outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100" /> -->
                <p-inputnumber [ngModel]="prepayChargeAmount()" (ngModelChange)="onChargeAmountChange($event)" [min]="0"
                  mode="decimal" [useGrouping]="true" inputId="integeronly" [max]="999999999999999" [clamp]="true"
                  class="bg-white rounded text-right  outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100">
                </p-inputnumber>
              </div>
              <div class="flex items-center justify-between">
                <span>{{
                  "CUSTMSTR0027" | translate
                  }}</span>
                <!-- <input type="text" [ngModel]="formatNumberWithCommas(balanceAfterTopUp())" readonly
                  class="border border-gray-300 bg-gray-100 px-3 py-2 rounded w-40 text-right  outline-none cursor-not-allowed" /> -->
                <p-inputnumber [ngModel]="balanceAfterTopUp()" [min]="0" inputId="integeronly" [readonly]="true"
                  class="bg-gray-100 rounded text-right  outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100" />
              </div>
            </div>
            <div class="flex gap-2">
              <button (click)="openTopUpPayment()"
                class="flex-1 py-3 w-full bg-indigo-600 text-white  rounded hover:bg-indigo-700 transition-colors shadow-sm">
                {{ "CUSTMSTR0010" | translate }}
              </button>
              <!-- <button class="flex-1 py-3 bg-gray-500 text-white  rounded hover:bg-gray-600">
                {{ "CUSTMSTR0011" | translate }}
              </button> -->
            </div>
          </div>
        </div>

        <div class="flex-1 flex flex-col min-w-0 bg-gray-50">
          <div class="flex bg-white border-b border-gray-200">
            <button (click)="historyTab.set('PREPAID')" class="flex-1 py-3  border-r border-gray-200"
              [class.bg-gray-600]="historyTab() === 'PREPAID'" [class.text-white]="historyTab() === 'PREPAID'"
              [class.bg-white]="historyTab() !== 'PREPAID'" [class.hover:bg-gray-50]="historyTab() !== 'PREPAID'">
              {{ "CUSTMSTR0008" | translate }}
            </button>
            <button (click)="historyTab.set('USAGE')" class="flex-1 py-3 "
              [class.bg-gray-600]="historyTab() === 'USAGE'" [class.text-white]="historyTab() === 'USAGE'"
              [class.bg-white]="historyTab() !== 'USAGE'" [class.hover:bg-gray-50]="historyTab() !== 'USAGE'">
              {{ "CUSTMSTR0009" | translate }}
            </button>
            <div class="flex-[2] bg-white border-l border-gray-200"></div>
          </div>
          <div class="flex-1 overflow-auto p-4">
            @switch (historyTab()) {
            @case ("PREPAID") {
            <app-material-table class="h-full" [headers]="prepaymentHeaders()" [data]="prepaymentHistory()"
              [key]="'seqNo'" [rowTemplate]="prepaymentRowTpl" [enablePagination]="true" [width]="'w-full'"
              [pageSize]="P_PAGEROW" (nextPage)="nextPageHistory($event)" [totalCnt]="totalCntHistory()"
              [isPaging]="true" [isNextPage]="isNextPageHistory()"></app-material-table>
            <ng-template #prepaymentRowTpl let-item>
              <tr
                [class]="selectedChargeHistory()?.seqNo == item.seqNo ? 'bg-indigo-50 border-indigo-200 hover:bg-gray-0' : 'hover:bg-gray-50 text-center cursor-pointer'"
                (click)="selectedChargeHistory.set(item);prepayChargeAmount.set(item.topUpAmount)">
                <!-- <td class="border-r border-gray-200 px-2">
                  <input type="checkbox" />
                </td> -->
                <td class="border-r border-b text-center border-gray-200 px-2 p-[0.4rem]">
                  {{ item.seqNo }}
                </td>
                <td class="border-r border-b text-center border-gray-200 px-2 p-[0.4rem] truncate">
                  {{ item.date }}
                </td>
                <td class="border-r border-b text-center border-gray-200 px-2 p-[0.4rem]">
                  {{ item.receiptNo }}
                </td>
                <td class="border-r border-b text-center border-gray-200 px-2 p-[0.4rem]">
                  {{ item.category }}
                </td>
                <td class="border-r border-b border-gray-200 text-right px-2 p-[0.4rem]">
                  {{ item.topUpAmount | currency: "" : "" : "1.0-0" }}
                </td>
                <td class="border-r border-b border-gray-200 text-right px-2 p-[0.4rem]">
                  {{ item.balance | currency: "" : "" : "1.0-0" }}
                </td>
                <td class="border-r border-b border-gray-200 text-center px-3">{{ item.cancellable }}</td>
                <td class="border-r border-b border-gray-200 px-3">
                  @if(item.canceL_FG == '0' && item.iS_CANCELED == 'N'){
                  <div class="w-full flex justify-center">
                    <button (click)="showConfirmCancel.set(true)"
                      class="flex justify-center items-center text-ellipsis bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors shadow-sm w-full 2xl:w-[100px] p-1">
                      {{'RECPTSTR0017' | translate}}
                    </button>
                  </div>
                  }

                </td>
              </tr>
            </ng-template>
            }
            @case ("USAGE") {
            <app-material-table class="h-full" [headers]="usageHeaders()" [data]="usageHistory()" [key]="'seqNo'"
              [width]="'w-full'" [rowTemplate]="usageRowTpl" [enablePagination]="true" [pageSize]="P_PAGEROW"
              (nextPage)="nextPageUse($event)" [totalCnt]="totalCntUse()" [isPaging]="true"
              [isNextPage]="isNextPageUse()"></app-material-table>
            <ng-template #usageRowTpl let-item>
              <tr class="h-10 hover:bg-gray-50 text-center ">
                <td class="border-r border-b border-gray-200 px-2">
                  {{ item.seqNo }}
                </td>
                <td class="border-r border-b border-gray-200 px-2">
                  {{ item.date }}
                </td>
                <td class="border-r border-b border-gray-200 px-2">
                  {{ item.receiptNo }}
                </td>
                <td class="border-r border-b border-gray-200 text-right px-3">
                  {{ item.usedAmount | currency: "" : "" : "1.0-0" }}
                </td>
                <td class="border-r border-b border-gray-200 text-right px-3">
                  {{ item.balance | currency: "" : "" : "1.0-0" }}
                </td>
                <td class="px-2 border-b">{{ item.category }}</td>
              </tr>
            </ng-template>
            }
            }
          </div>
        </div>
      </div>
    </div>
    }
    }
  </div>

  @if (isModalOpen()) {
  <div class="fixed inset-0 z-40 bg-black/50 transition-opacity" (click)="closeModal()"></div>
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-xl shadow-2xl w-[50vw] 2xl:w-[35vw]" (click)="$event.stopPropagation()">
      <div class="flex justify-between items-center p-5 border-b border-gray-200">
        <h3 class="fw-600 fs-16">
          {{ "CUSTMSTR0015" | translate }}
        </h3>
        <button (click)="closeModal()" class=" hover: transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>
      <div class="p-6">
        <div class="space-y-5 py-2 px-1">
          <div class="flex items-center gap-4">
            <label class="w-48">{{ "CUSTMSTR0016" |
              translate }}</label>
            <input type="text" [value]="newMemberId().slice(-13)" disabled
              class="flex-1 border border-gray-300 px-4 py-2.5 rounded-lg outline-none bg-gray-100 cursor-not-allowed transition-all"
              [placeholder]="''" />
          </div>
          <div class="flex items-center gap-4">
            <label class="w-48">{{ "CUSTMSTR0017" |
              translate }}</label>
            <input type="text" [ngModel]="newMemberName()" (ngModelChange)="newMemberName.set($event)" maxlength="50"
              class="flex-1 border border-gray-300 px-4 py-2.5 rounded-lg outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all"
              [placeholder]="'CUSTMSTR0017' | translate" />
          </div>
          <div class="flex gap-4">
            <label class="w-48 h-[40.5px] flex items-center"><span class="text-red-500 mr-0.5">*</span>{{
              "CUSTMSTR0018" |
              translate
              }}</label>
            <div class="flex-1">
              <input type="text" [ngModel]="newMemberPhone()" (input)="onPhoneInput($event)" placeholder="010-1234-1234"
                class="w-full border px-4 py-2.5 rounded-lg outline-none focus:ring-2 transition-all"
                [class.border-gray-300]="!phoneError()" [class.focus:border-indigo-500]="!phoneError()"
                [class.focus:ring-indigo-100]="!phoneError()" [class.border-red-500]="phoneError()"
                [class.focus:border-red-500]="phoneError()" [class.focus:ring-red-100]="phoneError()" />
              @if (phoneError()) {
              <p class="text-red-500 fs-12 mt-1">{{ phoneError() }}</p>
              }
            </div>
          </div>
          <div class="flex items-center gap-4">
            <label class="w-48">{{ "CUSTMSTR0019" |
              translate }}</label>
            <div class="flex-1 relative">
              <select [ngModel]="newMemberSms()" (ngModelChange)="newMemberSms.set($event)"
                class="w-full border border-gray-300 px-4 py-2.5 pr-10 rounded-lg outline-none focus:border-indigo-500 appearance-none bg-white">

                <option value="Y">{{ "CUSTMSTR0064" | translate }}</option>
                <option value="N">{{ "CUSTMSTR0065" | translate }}</option>
              </select>

              <div class="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                <svg class="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 rounded-b-xl">
        <div class="flex justify-center w-full gap-3">
          <button (click)="closeModal()"
            class="px-6 py-2.5 bg-white border border-gray-300   rounded-lg hover:bg-gray-50 transition-colors">
            {{ "SYSMESER0010" | translate }}
          </button>
          <button (click)="handleSaveNewMember()"
            class="px-8 py-2.5 bg-indigo-600 text-white  rounded-lg hover:bg-indigo-700 shadow-sm transition-colors">
            {{ "CUSTMSTR0007" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  }
</div>
<app-pop-up-common [showConfirm]="showConfirmDelete()" (confirmEvent)="delete()"
  (cancelEvent)="showConfirmDelete.set(false)" [message]="'SYSMESER0009'"></app-pop-up-common>
<app-pop-up-common-edit [show]="showEdit" [title]="'CUSTMSTR0015' | translate" [columns]="editColumns" [data]="editData"
  (saveEvent)="onSaveEdit($event)" (cancelEvent)="onCancelEdit()">
</app-pop-up-common-edit>

<app-pop-up-common [showConfirm]="showConfirmCancel()" (confirmEvent)="onClickCancelTopup()"
  (cancelEvent)="showConfirmCancel.set(false)" [message]="'RECPTSTR0094'"></app-pop-up-common>

<!-- Payment Method Selector -->
@if (showPaymentMethodSelector()) {
<app-payment-method-selector [amount]="prepayChargeAmount()" [title]="'CUSTMSTR0010'"
  (payComplete)="onPaymentSuccess($event)" [enablePoints]="selectedPrepayCustomer()?.prepaid ? true : false"
  (paymentCompleted)="onPaymentCompleted($event)" (cancelled)="onPaymentMethodCancelled()"
  [easyPayments]="easyPayments()" [paySuccess]="paySuccess()"></app-payment-method-selector>
}



@if(loading()){
<div class="loading-overlay">
  <div class="flex flex-col justify-center gap-4">
    <div class="flex items-center justify-center text-white w-full">
      <p>{{ loadingText() }}</p>
    </div>
    <div class="flex justify-center w-full">
      <div class="loader"></div>
    </div>
  </div>
</div>
}